const initialState = {
    fname: '',
    lname: '',
    mobile: '',
    national_code: '',
    phone: '',
    vehicle_model: '',
    plate: '',
    status: 'فعال',
};

const addCourier = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_ADD_COURIER':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default addCourier;
